// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Text-module__root--HK603 {
  box-sizing: border-box;
  margin: 0;
  color: #1a1a1a;
  font-family: inherit;
  font-size: 0.875rem; /* 14px */
  font-weight: 400;
  line-height: 1.5;
}

.Text-module__color-default--IJPfm {
  color: #1a1a1a;
}

.Text-module__color-secondary--RpuHV {
  color: #666;
}

.Text-module__color-muted--Srt_5 {
  color: #888;
}

.Text-module__color-accent--wLweq {
  color: #a05a27;
}

.Text-module__color-error--xEu3l {
  color: #c92a24;
}

.Text-module__color-inverse--k1gYG {
  color: #fff;
}

.Text-module__size-xx-small--rJH0W {
  font-size: 0.6875rem; /* 11px */
}

.Text-module__size-x-small--jRzFo {
  font-size: 0.75rem; /* 12px */
}

.Text-module__size-small--s8O9T {
  font-size: 0.8125rem; /* 13px */
}

.Text-module__size-medium--JedJV {
  font-size: 0.875rem; /* 14px */
}

.Text-module__size-large--SBYtD {
  font-size: 0.9375rem; /* 15px */
}

.Text-module__size-x-large--bxoHT {
  font-size: 1rem; /* 16px */
}

.Text-module__is-strong--OIEc6 {
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Text/Text.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,eAAe,EAAE,SAAS;AAC5B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".root {\n  box-sizing: border-box;\n  margin: 0;\n  color: #1a1a1a;\n  font-family: inherit;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.color-default {\n  color: #1a1a1a;\n}\n\n.color-secondary {\n  color: #666;\n}\n\n.color-muted {\n  color: #888;\n}\n\n.color-accent {\n  color: #a05a27;\n}\n\n.color-error {\n  color: #c92a24;\n}\n\n.color-inverse {\n  color: #fff;\n}\n\n.size-xx-small {\n  font-size: 0.6875rem; /* 11px */\n}\n\n.size-x-small {\n  font-size: 0.75rem; /* 12px */\n}\n\n.size-small {\n  font-size: 0.8125rem; /* 13px */\n}\n\n.size-medium {\n  font-size: 0.875rem; /* 14px */\n}\n\n.size-large {\n  font-size: 0.9375rem; /* 15px */\n}\n\n.size-x-large {\n  font-size: 1rem; /* 16px */\n}\n\n.is-strong {\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Text-module__root--HK603`,
	"color-default": `Text-module__color-default--IJPfm`,
	"color-secondary": `Text-module__color-secondary--RpuHV`,
	"color-muted": `Text-module__color-muted--Srt_5`,
	"color-accent": `Text-module__color-accent--wLweq`,
	"color-error": `Text-module__color-error--xEu3l`,
	"color-inverse": `Text-module__color-inverse--k1gYG`,
	"size-xx-small": `Text-module__size-xx-small--rJH0W`,
	"size-x-small": `Text-module__size-x-small--jRzFo`,
	"size-small": `Text-module__size-small--s8O9T`,
	"size-medium": `Text-module__size-medium--JedJV`,
	"size-large": `Text-module__size-large--SBYtD`,
	"size-x-large": `Text-module__size-x-large--bxoHT`,
	"is-strong": `Text-module__is-strong--OIEc6`
};
export default ___CSS_LOADER_EXPORT___;
